import React, { useContext } from 'react';
import { GameInterfaceContext } from '../../providers/GameInterfaceProvider';
import { GameInterface } from '../../settings/interface';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface WrapperProps {
	disabled: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  z-index: 100;
  width: 6vmin;
  height: 6vmin;
  pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};
  grid-column: 2/3;
  margin: 0 auto;
  margin-top: 4vmin;
  cursor: pointer;
`;

const Icon = styled.div`
  width: 100%;
  height: 100%;
  background: url('./assets/oldTheme/shortcut-icon.jpg') bottom left /1.5vmin no-repeat border-box, url('./assets/oldTheme/icon.webp') 0/6vmin no-repeat border-box;;
  margin: 0 auto;
  margin-bottom:  0.2vmin;
  cursor: pointer;
`;

const ProgramShortcut = () => {
	const { t } = useTranslation();
	const { gameInterface, setGameInterface } = useContext(GameInterfaceContext);

	const openGame = (): void => {
		setGameInterface((prev: GameInterface) => {
			if (!prev.isVisible) {
				return { isVisible: true };
			} else return { ...prev };
		});
	};

	return (
		<Wrapper disabled={gameInterface.isVisible} onClick={openGame}>
			<Icon/>
			<h4 style={{ color: 'white', textAlign: 'start', marginTop: '1vmin' }}>{t('GameName')}</h4>
		</Wrapper>
	);
};

export default ProgramShortcut;